import axios from 'axios'
import '@/api'
import { extract } from './utils'
import { merge } from 'lodash'

// ------------------------------------
// Endpoint Configuration
// ------------------------------------

const endpointConfig = {
  url: '/customers'
}

// ------------------------------------
// Initial State
// ------------------------------------

const state = {
  customer: {},
  customers: []
}

// ------------------------------------
// Getters
// ------------------------------------

const getters = {
  customer: state => state.customer,
  customers: state => state.customers
}

// ------------------------------------
// Constants
// ------------------------------------

const REQUEST_GET_CUSTOMER = 'REQUEST_GET_CUSTOMER'
const RECEIVE_GET_CUSTOMER = 'RECEIVE_GET_CUSTOMER'

const REQUEST_CREATE_CUSTOMER = 'REQUEST_CREATE_CUSTOMER'
const RECEIVE_CREATE_CUSTOMER = 'RECEIVE_CREATE_CUSTOMER'

const REQUEST_UPDATE_CUSTOMER = 'REQUEST_UPDATE_CUSTOMER'
const RECEIVE_UPDATE_CUSTOMER = 'RECEIVE_UPDATE_CUSTOMER'

const REQUEST_DELETE_CUSTOMER = 'REQUEST_DELETE_CUSTOMER'
const RECEIVE_DELETE_CUSTOMER = 'RECEIVE_DELETE_CUSTOMER'

const UPDATE_CUSTOMER_PROPERTY = 'UPDATE_CUSTOMER_PROPERTY'

const REQUEST_GET_CUSTOMERS = 'REQUEST_GET_CUSTOMERS'
const RECEIVE_GET_CUSTOMERS = 'RECEIVE_GET_CUSTOMERS'

// ------------------------------------
// Actions
// ------------------------------------

const actions = {
  async getCustomers ({ commit, dispatch }, { includes = undefined, filters = undefined, sort = undefined }) {
    dispatch('wait/start', 'getting customers', { root: true })
    commit(REQUEST_GET_CUSTOMERS)
    const config = merge({}, endpointConfig, { params: merge({}, filters, { include: includes }, { sort: sort }) })
    return axios.get(endpointConfig.url, config)
      .then((response) => {
        dispatch('receiveCustomers', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting customers', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting customers', { root: true })
        return Promise.reject(error)
      })
  },
  async getCustomer ({ commit, dispatch }, { id, includes = undefined }) {
    dispatch('wait/start', 'getting customer', { root: true })
    commit(REQUEST_GET_CUSTOMER, id)
    const config = merge({}, endpointConfig, { params: { include: includes } })
    return axios.get(`${endpointConfig.url}/${id}`, config)
      .then((response) => {
        dispatch('receiveCustomer', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting customer', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting customer', { root: true })
        return Promise.reject(error)
      })
  },
  receiveCustomer ({ commit, dispatch }, [ json, action ]) {
    commit(`RECEIVE_${action}_CUSTOMER`, extract(json))
    return json.data
  },
  receiveCustomers ({ commit, dispatch }, [ json, action ]) {
    commit(`RECEIVE_${action}_CUSTOMERS`, extract(json))
    return json.data
  },
  updateCustomerProperty ({ commit, dispatch }, [ property, value ]) {
    commit(`UPDATE_CUSTOMER_PROPERTY`, [ property, value ])
  }
}

// ------------------------------------
// Mutations
// ------------------------------------

const mutations = {
  [REQUEST_GET_CUSTOMER](state, id) {
  },
  [RECEIVE_GET_CUSTOMER](state, json) {
    state.customer = json
  },
  [REQUEST_CREATE_CUSTOMER](state, json) {
  },
  [RECEIVE_CREATE_CUSTOMER](state, json) {
    state.customer = json
  },
  [REQUEST_UPDATE_CUSTOMER](state, id) {
  },
  [RECEIVE_UPDATE_CUSTOMER](state, json) {
    state.customer = json
  },
  [REQUEST_DELETE_CUSTOMER](state, id) {
  },
  [RECEIVE_DELETE_CUSTOMER](state, json) {
    state.customer = {}
  },
  [UPDATE_CUSTOMER_PROPERTY](state, [property, value]) {
    state.customer[property] = value
  },
  [REQUEST_GET_CUSTOMERS](state) {
  },
  [RECEIVE_GET_CUSTOMERS](state, json) {
    state.customers = json
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
